// Simple and effective header behavior
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu functionality
  const mobileMenu = document.getElementById('mobile-menu');
  const menuToggle = document.querySelector('.sh-menu-toggle');
  const menuClose = document.querySelector('.sh-mobile-menu__close');
  const menuOverlay = document.querySelector('.sh-mobile-menu__overlay');
  
  // Open mobile menu
  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        this.setAttribute('aria-expanded', 'true');
      }
    });
  }
  
  // Close mobile menu
  if (menuClose) {
    menuClose.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.remove('is-active');
        document.body.style.overflow = '';
        if (menuToggle) {
          menuToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }
  
  // Close menu when clicking overlay
  if (menuOverlay) {
    menuOverlay.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.remove('is-active');
        document.body.style.overflow = '';
        if (menuToggle) {
          menuToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }
  
  // Close menu with Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-active')) {
      mobileMenu.classList.remove('is-active');
      document.body.style.overflow = '';
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    }
  });
  
  // Sticky header behavior
  const header = document.querySelector('.sh-header');
  let lastScrollTop = 0;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (header) {
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Scrolling down
        header.dataset.scrollDirection = 'down';
        header.dataset.stickyState = 'condensed';
      } else if (scrollTop < lastScrollTop) {
        // Scrolling up
        header.dataset.scrollDirection = 'up';
        header.dataset.stickyState = 'active';
      }
      
      if (scrollTop <= 100) {
        header.dataset.stickyState = 'inactive';
      }
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Throttle scroll events for better performance
  let ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', requestTick, { passive: true });
  
  // Update header height CSS variable
  function updateHeaderHeight() {
    if (header) {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }
  
  // Initial height update
  updateHeaderHeight();
  
  // Update height on resize
  window.addEventListener('resize', updateHeaderHeight);
  
  // Close mobile menu on resize if screen becomes large
  function handleResize() {
    if (window.innerWidth >= 700 && mobileMenu && mobileMenu.classList.contains('is-active')) {
      mobileMenu.classList.remove('is-active');
      document.body.style.overflow = '';
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    }
    updateHeaderHeight();
  }
  
  window.addEventListener('resize', handleResize);

  // Fly-to-cart animation helper
  window.flyToCartFromElement = function(sourceEl, imgSrc) {
    try {
      function isVisible(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
      }
      function findCartBadge() {
        const candidates = [
          document.querySelector('.sh-header-mobile .sh-iconbtn[aria-label="Cart"] .sh-badge[data-cart-count="true"]'),
          document.querySelector('.sh-header .sh-iconbtn[aria-label="Cart"] .sh-badge[data-cart-count="true"]'),
          document.querySelector('.sh-header-mobile .sh-iconbtn[aria-label="Cart"] .sh-badge'),
          document.querySelector('.sh-header .sh-iconbtn[aria-label="Cart"] .sh-badge')
        ];
        for (const el of candidates) {
          if (isVisible(el)) return el;
        }
        // Fallback to any visible badge
        const anyBadges = document.querySelectorAll('.sh-iconbtn--badge .sh-badge');
        for (const el of anyBadges) {
          if (isVisible(el)) return el;
        }
        return null;
      }
      const cartBadge = findCartBadge();
      if (!cartBadge) return;
      const img = imgSrc || (sourceEl && sourceEl.querySelector('img') && sourceEl.querySelector('img').src);
      const sourceRect = (sourceEl && sourceEl.getBoundingClientRect()) || { left: window.innerWidth/2, top: window.innerHeight/2, width: 40, height: 40 };
      const targetRect = cartBadge.getBoundingClientRect();

      const ghost = document.createElement('img');
      ghost.src = img || '';
      ghost.alt = '';
      ghost.style.position = 'fixed';
      ghost.style.left = sourceRect.left + 'px';
      ghost.style.top = sourceRect.top + 'px';
      ghost.style.width = Math.max(40, sourceRect.width) + 'px';
      ghost.style.height = Math.max(40, sourceRect.height) + 'px';
      ghost.style.objectFit = 'contain';
      ghost.style.zIndex = '10000';
      ghost.style.pointerEvents = 'none';
      ghost.style.willChange = 'transform, opacity';
      ghost.style.transition = 'transform 900ms cubic-bezier(0.16, 1, 0.3, 1), opacity 900ms ease';
      document.body.appendChild(ghost);

      const dx = (targetRect.left + targetRect.width / 2) - (sourceRect.left + sourceRect.width / 2);
      const dy = (targetRect.top + targetRect.height / 2) - (sourceRect.top + sourceRect.height / 2);
      const scale = 0.2;

      // Prefer Web Animations API for smoother curved motion
      const distance = Math.hypot(dx, dy);
      const arcLift = Math.min(120, distance * 0.25); // curve height
      let finished = false;
      if (ghost.animate) {
        const animation = ghost.animate([
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
          { transform: `translate(${dx * 0.6}px, ${dy * 0.4 - arcLift}px) scale(0.85)`, opacity: 0.9 },
          { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.15 }
        ], {
          duration: Math.min(1200, Math.max(700, 250 + distance)),
          easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          fill: 'forwards'
        });
        animation.addEventListener('finish', () => {
          finished = true;
          if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
          try {
            const cartAnchor = cartBadge.closest('.sh-iconbtn');
            if (cartAnchor) {
              cartAnchor.classList.add('sh-cart-animate');
              setTimeout(() => cartAnchor.classList.remove('sh-cart-animate'), 800);
            }
          } catch(e){}
        });
      }
      // Fallback: simple transition straight-line
      if (!finished) {
        requestAnimationFrame(() => {
          ghost.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
          ghost.style.opacity = '0.2';
        });
      }

      ghost.addEventListener('transitionend', () => {
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
        // Highlight cart button with CSS animation
        try {
          const cartAnchor = cartBadge.closest('.sh-iconbtn');
          if (cartAnchor) {
            cartAnchor.classList.add('sh-cart-animate');
            setTimeout(() => cartAnchor.classList.remove('sh-cart-animate'), 800);
          } else {
            // Fallback: tiny pulse on badge
            cartBadge.style.transition = 'transform 200ms ease';
            cartBadge.style.transform = 'scale(1.2)';
            setTimeout(()=>{ cartBadge.style.transform=''; }, 220);
          }
        } catch(e){}
      }, { once: true });
    } catch (e) {
      // ignore animation errors
    }
  }
});
